import { filters } from '@/framework';

export default {
  install(Vue) {
    filters(Vue, []);
  },
};



// WEBPACK FOOTER //
// ./src/filters/index.js